export const colors = {
    background: '#1a202c',
    primary: '#81e6d9',
    secondary: '#9f7aea',
    text: '#e2e8f0',
    accent: '#f687b3',
    card: '#2d3748'
  };